var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("test-template", {
        attrs: { testName: _vm.testName, testId: _vm.testId, test: _vm.test },
        scopedSlots: _vm._u([
          {
            key: "questions",
            fn: function() {
              return [
                _vm.cQ && _vm.cQ.answer.length === 0
                  ? _c("b-card", { staticClass: "neu-card" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.cQ.question))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-flex" },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                                lg: "6"
                                              }
                                            },
                                            [
                                              _c(
                                                "base-input",
                                                {
                                                  staticClass: "inputAnswer",
                                                  attrs: {
                                                    type: "number",
                                                    placeholder: _vm.$t(
                                                      "tests.findrisk.heightPH"
                                                    ),
                                                    min: "1",
                                                    max: "250"
                                                  },
                                                  model: {
                                                    value: _vm.height,
                                                    callback: function($$v) {
                                                      _vm.height = $$v
                                                    },
                                                    expression: "height"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tests.findrisk.heightUnit"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                                lg: "6"
                                              }
                                            },
                                            [
                                              _c(
                                                "base-input",
                                                {
                                                  staticClass: "inputAnswer",
                                                  attrs: {
                                                    type: "number",
                                                    placeholder: _vm.$t(
                                                      "tests.findrisk.weightPH"
                                                    ),
                                                    min: "1",
                                                    step: "0.1"
                                                  },
                                                  model: {
                                                    value: _vm.weight,
                                                    callback: function($$v) {
                                                      _vm.weight = $$v
                                                    },
                                                    expression: "weight"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tests.findrisk.weightUnit"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                  attrs: { xs: "12", lg: "8" }
                                },
                                [
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade", appear: "" } },
                                    [
                                      _vm.height &&
                                      _vm.weight &&
                                      _vm.weight != 0 &&
                                      _vm.height != 0
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary w-100",
                                              attrs: { type: "button" },
                                              on: {
                                                "~click": function($event) {
                                                  return _vm.saveIMC.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "tests.findrisk.IMC"
                                                      )
                                                    ) +
                                                      ": " +
                                                      _vm._s(_vm.calculateIMC)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "float-right m-auto"
                                                },
                                                [
                                                  _c("base-icon", {
                                                    attrs: {
                                                      src:
                                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                      color: "white"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _c("question-card", {
                      attrs: {
                        question: _vm.cQ,
                        labelsEnabled: "",
                        progress: _vm.$store.state.tests.currentSlide,
                        stacked: "",
                        questionnaireLength: _vm.$store.state.tests.test.length
                      },
                      on: {
                        answerQuestion: function() {
                          _vm.$store.commit("tests/incrementSlide")
                        },
                        submitQuestionnaire: _vm.saveTestResults
                      },
                      model: {
                        value: _vm.questionResult,
                        callback: function($$v) {
                          _vm.questionResult = $$v
                        },
                        expression: "questionResult"
                      }
                    })
              ]
            },
            proxy: true
          },
          {
            key: "results",
            fn: function() {
              return [
                _c("div", { staticClass: "first" }, [
                  _c("h3", { staticClass: "subtitle-card text-center" }, [
                    _vm._v(
                      _vm._s(_vm.$t("tests.testResults")) +
                        " - " +
                        _vm._s(_vm.testName.toUpperCase())
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "second" },
                  [
                    _c(
                      "b-card",
                      {
                        staticClass:
                          "neu-card pt-0 col-lg-7 h-auto mean-result bg-warning"
                      },
                      [
                        _c("p", {
                          staticClass: "card-text text-justify",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("tests.findrisk.cantReplaceDiagnosis")
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "neu-card col-lg-7 h-auto mean-result" },
                      [
                        _c("h3", { staticClass: "subtitle-card d-block" }, [
                          _vm._v(" " + _vm._s(_vm.testName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "h5",
                          {
                            staticClass: "subtitle-card d-block",
                            style: "color: " + _vm.resultInfo.color
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.resultInfo.tag.toUpperCase())
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.DBResults.generalResult >= 15
                          ? _c("p", {
                              staticClass: "p-white",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("tests.findrisk.tips.highRiskTip")
                                )
                              }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      _vm._l(3, function(n) {
                        return _c(
                          "b-row",
                          { key: n, staticClass: "col-lg-4 results-card px-2" },
                          [
                            _c(
                              "b-card",
                              { staticClass: "neu-card" },
                              [
                                _c("base-icon", {
                                  class: {
                                    "d-inline-block": _vm.$uiHelpers.isMobile
                                  },
                                  attrs: {
                                    src:
                                      "/static-appopensalud/img/icons/morillas-svg-icons/primary/findRisktip" +
                                      n +
                                      ".svg",
                                    alt: "",
                                    height: _vm.iconSize,
                                    width: _vm.iconSize,
                                    color: "blue"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "card-text text-justify",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("tests.findrisk.tips.tip" + n)
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f014edfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f014edfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/selfEvaluationTests/FindRiskTest.vue
// module id = 4161
// module chunks = 142